import * as CL from '@design-system/component-library';
import { pcsMsg, t } from '../../common/i18n/index.js';
import { formatSum, getRecurringPriceAsText } from '../../common/utils/priceUtils.js';
import { getProductCategoryDetails } from '../CatalogProductsSelection/CatalogProductSelectionUtils.js';
import { PriceLoadingValue } from '../PriceLoadingValue/PriceLoadingValue.js';
import { Table } from '../Table';
import type { CLTableColumn } from '../../common/types/componentLibrary';
import type { CatalogProduct, SupportedModelCategory } from '../../common/utils/catalogUtils.js';

import './CatalogProductSummary.scss';

interface CatalogProductsSummaryProps {
  products: Record<SupportedModelCategory, Array<CatalogProduct>>;
}

export const CatalogProductsSummary = ({ products }: CatalogProductsSummaryProps) => {
  const columns: CLTableColumn[] = [{ key: 'name' }, { key: 'price' }];

  return (
    <div className="of-catalog-product-summaries">
      {Object.values(products).every(value => !value.length) ? (
        <p> {t.UVCL('No products in catalogue.')} </p>
      ) : (
        Object.entries(products).map(([category, product = []]: [SupportedModelCategory, CatalogProduct[]]) => {
          const { displayText, showAdditionalInfo } = getProductCategoryDetails(category);
          const items = product.map(({ manufacturer, monthlyRecurringCharge, name, oneTimeCharge, isPriceLoading }) => {
            const productName = `${manufacturer} ${name}`;
            const price =
              formatSum(oneTimeCharge) || `${t.OD1L('Starting at')} ${getRecurringPriceAsText(monthlyRecurringCharge)}`;
            return {
              name: <>{productName}</>,
              price: isPriceLoading ? <PriceLoadingValue showSecondary={false} /> : <>{price}</>,
            };
          });

          const additionalInfo = showAdditionalInfo
            ? t.X32V('The device selected for the list includes all available memory and colour variations.')
            : '';

          return (
            items.length > 0 && (
              <div key={category} id={`catalog-product-summary-${category}`}>
                <CL.Description
                  columns={1}
                  items={[{ title: `${displayText} (${items.length} ${t.B3MG(pcsMsg)})`, description: additionalInfo }]}
                />
                <Table columns={columns} rows={items} tableType="bordered" showHeaders={false} />
              </div>
            )
          );
        })
      )}
    </div>
  );
};
